import { useAuth } from '@/components/Auth/AuthProvider';
import { getOrganizationId, isOrganization, isTeamMember, getOrganizationName } from '@/utils/organization';
import { useState, useEffect } from 'react';


export const useOrganization = () => {
  const { user } = useAuth();
  const [organizationId, setOrganizationId] = useState<string>('');
  const [organizationName, setOrganizationName] = useState<string | null>(null);
  const [isOrg, setIsOrg] = useState(false);
  const [isTeam, setIsTeam] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!user) {
      setOrganizationId('');
      setOrganizationName(null);
      setIsOrg(false);
      setIsTeam(false);
      setLoading(false);
      return;
    }

    const loadOrganization = async () => {
      setLoading(true);
      try {
        // Get organization ID (handles both solo and team users)
        const orgId = await getOrganizationId(user.id, user.email);
        setOrganizationId(orgId);
        
        // Get organization name (company_name from user_profiles)
        const orgName = await getOrganizationName(orgId);
        setOrganizationName(orgName);
        
        // Check if user is an organization
        const orgCheck = await isOrganization(user.id);
        setIsOrg(orgCheck);
        
        // Check if user is a team member
        const teamCheck = await isTeamMember(user.email);
        setIsTeam(teamCheck);
        
      } catch (error) {
        console.error('Error loading organization:', error);
        // Fallback values
        setOrganizationId(user.id);
        setOrganizationName(null);
        setIsOrg(false);
        setIsTeam(false);
      } finally {
        setLoading(false);
      }
    };

    loadOrganization();
  }, [user]);

  return {
    organizationId,           // Always returns a valid ID for database queries
    organizationName,         // Company name for display (null if individual user)
    isOrganization: isOrg,    // true if user has company_name
    isTeamMember: isTeam,     // true if user is non-admin team member
    loading
  };
};